import { create } from 'zustand';

interface AccessibilityState {
  highContrast: boolean;
  toggleHighContrast: () => void;
}

export const useAccessibilityStore = create<AccessibilityState>((set) => ({
  highContrast: false,
  toggleHighContrast: () => set((state) => ({ highContrast: !state.highContrast })),
})); 